<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <BackButton back_url="login"></BackButton>
    </FabColumn>

    <ion-content class="auth-content register-content">
      <MainTitle class="auth-title" text="註冊帳戶"></MainTitle>
      <InputBox class="auth-input" text="手提電話號碼" placeholder="請輸入手提電話號碼" margin_top="short" @getValue="getMobileValue"></InputBox>
      <div class="clause">
        <input type="checkbox" v-model="clause" class="checkbox">
        <LoginBottomTips text="我已閱讀並同意" class="clause-text" @click="toggleClause"></LoginBottomTips>
        <!-- 條款彈框 -->
        <LoginBottomTips text="服務條款及免責聲明" class="terms-text" @click="showAlert">
        </LoginBottomTips>
      </div>
      <ConfirmButton class="auth-button" text="繼續" position="relative" @click="doRegister"></ConfirmButton>
    </ion-content>

    <AlertModal :element="this"></AlertModal>
  </ion-page>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import LoginBottomTips from "../components/login/LoginBottomTips";
import MainTitle from "../components/common/MainTitle";
import BackButton from "../components/common/BackButton";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import InputBox from "../components/common/InputBox";
import AlertModal from "../components/common/AlertModal";

export default {
  name: "Register",
  components: {
    AlertModal,
    InputBox,
    ConfirmButton,
    BackButton,
    MainTitle,
    LoginBottomTips,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      common: common,
      mobile: '',
      clause: false,
    }
  },
  methods: {
    getMobileValue: function (value) {
      this.mobile = value;
    },
    doRegister: function () {

      if (this.mobile.trim().length === 0) {
        common.showAlert('請輸入您的手提電話號碼。')
        return false;
      }
      if (!this.clause) {
        common.showAlert('請先閱讀並同意條款及細則。')
        return false;
      }

      const loading = common.showLoading();
      common.apiPostData('/registerMobile', { mobile: this.mobile, clause: this.clause ? 1 : 0 }, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/mobileVerify/' + this.mobile + '/register')
      })
    },
    toggleClause: function () {
      this.clause = !this.clause;
    },
    showAlert: function () {
      this.common.config.alertModal.isOpen = true;
      this.common.config.alertModal.title = '服務條款及免責聲明';
      this.common.config.alertModal.content = [
        '服務條款',
        '——————————————————————————',
        '此「中大網上認知測試」能夠協助長者及家人偵測早期認知障礙症（腦退化症）徵兆，整個測試有大約 10 數條問題，大概只需要 5-10分鐘便可完成。',
        '在使用本測試前，請細閱以下聲明：',
        '「中大網上認知測試」是一項自我測試的篩選工具，用以對認知障礙症作出初步檢測，並不能視之為取代專業臨床認知評估。研究顯示，此測試能準確地偵測早期認知障礙症徵兆，如懷疑自己或家人患上認知障礙症，建議閣下盡快尋求專業的協助，作進一步深入檢查。',
        "",
        '免責聲明',
        '——————————————————————————',
        '「中大網上認知測試」並不是一個診斷腦退化症的檢測。測試結果不僅會受到測試者的認知健康影響，還可能會被與大腦健康無關的其他因素所影響，因此測試結果並不能完全反映您的認知健康。香港中文大學和香港賽馬會不會就您的測試結果提供任何醫療保健服務。如果您擔心自己的認知健康，建議您徵詢您的醫生意見，以進行正式評估和或治療。',
        'This E-Cognitive (EC) Screen is not a diagnostic test for dementia. Your test results may be affected not only by your cognitive health, but also other factors not related to it. Therefore, the test results do not fully reflect your cognitive health. The Chinese University of Hong Kong and the Hong Kong Jockey Club are not liable to provide any healthcare service in response to your test results. You are encouraged to seek medical attention for formal assessment and/or treatment if you are concerned about your cognitive health.',
      ]

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.common.config.alertModal.didDismissFun = function () {
        that.common.config.alertModal.isOpen = false;
      }
    },
  }
}
</script>

<style scoped>
.clause {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.375rem, 1vw, 0.625rem);
  margin-top: clamp(0.5rem, 1.5vh, 0.875rem);
}

.checkbox {
  margin: 0;
}

.clause-text,
.terms-text {
  display: inline-block;
  margin-top: 0;
}

.clause-text {
  color: black;
  cursor: pointer;
}
</style>
